<template>
    <div class="kim-background"></div>
</template>

<script>
export default {
  name: 'KimBackground',
};
</script>

<style scoped type="text/scss">
.kim-background{
  //z-index: -1;
  background-image: url('/background.svg');
  background-repeat: no-repeat;
  background-size: contain;
  opacity: .66;
  top: 20%;
  bottom: -12%;
  right: -8%;
  width: 45%;
  position: fixed;
}
</style>
